import { Map } from "ol";
import { createContext } from "react";

const MapContext = createContext(new Map({}));
export default MapContext;